<mat-accordion id="casing-history-accordion" multi="true">
  <mat-expansion-panel id="casing-history-panel" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mic-icon class="mr-2" icon="history" fontSet="outlined"></mic-icon>
        {{ translationService.translate('casingHistoryText') }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-divider></mat-divider>

    <div class="history-view-selector my-3">
      <span id="casing-history-view-label">{{ translationService.translate('casingHistoryViewsText') }}</span>
      <mat-button-toggle-group
        multiple
        [value]="selectedViews"
        (change)="setViews($event.value)"
        aria-labelledby="casing-history-view-label"
      >
        <mat-button-toggle value="table">
          <mat-icon aria-hidden="true">table_chart</mat-icon>
          {{ translationService.translate('casingHistoryTableViewText') }}
        </mat-button-toggle>
        <mat-button-toggle value="timeline">
          <mat-icon aria-hidden="true">timeline</mat-icon>
          {{ translationService.translate('casingHistoryTimelineViewText') }}
        </mat-button-toggle>
        <mat-button-toggle value="lifecycle">
          <mat-icon aria-hidden="true">account_tree</mat-icon>
          {{ translationService.translate('casingHistoryLifecycleViewText') }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    @for (errorKey of loadErrorKeys; track errorKey) {
    <p role="alert">{{ translationService.translate(errorKey) }}</p>
    } @if (loadingCasingHistory) {
    <div class="flex justify-center py-4">
      <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    </div>
    } @if (!loadingCasingHistory) { @if (selectedViews.length === 0) {
    <p role="status">{{ translationService.translate('casingHistorySelectViewText') }}</p>
    } @if (selectedViews.includes('table')) {
    <div id="casing-history-table-container" style="max-height: 300px; overflow: auto">
      <mic-table id="casing-history-table" class="table-stripped" [config]="casingHistoryTableConfig" [dataSource]="casingHistory">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"> </mic-empty-state>
        </ng-container>
      </mic-table>
    </div>
    }
    <div class="history-diagram-views">
      @if (selectedViews.includes('timeline')) {
      <section class="history-diagram" aria-labelledby="casing-history-timeline-title">
        <h3 id="casing-history-timeline-title">{{ translationService.translate('casingHistoryTimelineViewText') }}</h3>
        <p>{{ translationService.translate('casingHistoryNewestFirstText') }}</p>
        @if (casingHistory.data.length === 0) {
        <mic-empty-state icon="layers_clear" [title]="translationService.translate('emptyTableText')"></mic-empty-state>
        } @else {
        <ol class="history-timeline">
          @for (row of casingHistory.data; track row) {
          <li class="history-timeline-item">
            <span class="history-timeline-marker" aria-hidden="true">
              <mat-icon>{{
                eventStage(row) === 'creation' ? 'add_circle_outline' : eventStage(row) === 'shopFloor' ? 'factory' : 'edit_note'
              }}</mat-icon>
            </span>
            <article class="history-event">
              <p class="history-event-date">
                {{ eventValue(row, 'creationDate') || translationService.translate('casingHistoryDateUnknownText') }}
              </p>
              <h4>{{ eventValue(row, 'sfAction') || translationService.translate('casingHistoryActionUnknownText') }}</h4>
              <ng-container [ngTemplateOutlet]="eventMetadata" [ngTemplateOutletContext]="{ $implicit: row }"></ng-container>
            </article>
          </li>
          }
        </ol>
        }
      </section>
      } @if (selectedViews.includes('lifecycle')) {
      <section class="history-diagram" aria-labelledby="casing-history-lifecycle-title">
        <h3 id="casing-history-lifecycle-title">{{ translationService.translate('casingHistoryLifecycleViewText') }}</h3>
        <p>{{ translationService.translate('casingHistoryStageExplanationText') }}</p>
        <ol class="history-lifecycle">
          @for (stage of lifecycleStages; track stage.id; let index = $index) {
          <li class="history-stage">
            <div class="history-stage-heading">
              <span class="history-stage-number" aria-hidden="true">{{ index + 1 }}</span>
              <mat-icon aria-hidden="true">{{ stage.icon }}</mat-icon>
              <h4>{{ translationService.translate(stage.labelKey) }}</h4>
            </div>
            <p>{{ translationService.translate('casingHistoryRecordedEventsText') }}: {{ stageRows[stage.id].length }}</p>
            @if (stageRows[stage.id].length === 0) {
            <p>{{ translationService.translate('casingHistoryNoStageEventsText') }}</p>
            } @else {
            <ol class="history-stage-events">
              @for (row of stageRows[stage.id]; track row) {
              <li>
                <article class="history-event">
                  <p class="history-event-date">
                    {{ eventValue(row, 'creationDate') || translationService.translate('casingHistoryDateUnknownText') }}
                  </p>
                  <h4>{{ eventValue(row, 'sfAction') || translationService.translate('casingHistoryActionUnknownText') }}</h4>
                  <ng-container [ngTemplateOutlet]="eventMetadata" [ngTemplateOutletContext]="{ $implicit: row }"></ng-container>
                </article>
              </li>
              }
            </ol>
            }
          </li>
          }
        </ol>
      </section>
      }
    </div>
    }
  </mat-expansion-panel>
</mat-accordion>

<ng-template #eventMetadata let-row>
  <dl class="history-event-metadata">
    <div>
      <dt>{{ translationService.translate('workOrderLineDetailsUserText') }}</dt>
      <dd>{{ eventValue(row, 'user') || translationService.translate('casingHistoryNotRecordedText') }}</dd>
    </div>
    <div>
      <dt>{{ translationService.translate('workOrderLineDetailsPostText') }}</dt>
      <dd>{{ eventValue(row, 'post') || translationService.translate('casingHistoryNotRecordedText') }}</dd>
    </div>
    @if (eventValue(row, 'sfPlant')) {
    <div>
      <dt>{{ translationService.translate('workOrderLineDetailsPlantSiteText') }}</dt>
      <dd>{{ eventValue(row, 'sfPlant') }}</dd>
    </div>
    }
  </dl>
</ng-template>
